// Copyright 2020 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { CanvasMediaObjectLinkDTO, TargetRegionLinkProperties } from "datatypes/SoramaWebApi";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { IDeletableRepository, IRetrievableRepository } from "./IGenericRepository";

export abstract class ICanvasMediaObjectLinkRepository
    implements IRetrievableRepository<CanvasMediaObjectLinkDTO>, IDeletableRepository
{
    /**
     * Retrieve a CanvasMediaObjectLink.
     * @param canvasId Id of the CanvasMediaObjectLink to retrieve.
     */
    public abstract get(linkId: string): Promise<CanvasMediaObjectLinkDTO>;

    /**
     * Update the properties field of a CanvasMediaObjectLink.
     * @param linkId Id of the CanvasMediaObjectLink to update.
     * @param newProperties New properties to set.
     */
    public abstract updateProperties(linkId: string, newProperties: TargetRegionLinkProperties): Promise<void>;

    /**
     * Delete a CanvasMediaObjectLink.
     * @param canvasId Id of the CanvasMediaObjectLink to delete.
     */
    public abstract delete(linkId: string): Promise<void>;
}

@autoinject
export class CanvasMediaObjectLinkRepository implements ICanvasMediaObjectLinkRepository {
    constructor(private readonly webRequestHandler: IWebRequestHandler) {}

    public get(linkId: string): Promise<CanvasMediaObjectLinkDTO> {
        return this.webRequestHandler
            .createGetRequest<CanvasMediaObjectLinkDTO>(Api.canvasMediaObjectLinks + "/" + linkId)
            .send()
            .then((x) => x.content);
    }

    public updateProperties(linkId: string, newProperties: TargetRegionLinkProperties): Promise<void> {
        return this.webRequestHandler
            .createPutRequest(Api.canvasMediaObjectLinks + "/" + linkId + "/Properties", newProperties)
            .send()
            .then(() => {});
    }

    public delete(linkId: string): Promise<void> {
        return this.webRequestHandler
            .createDeleteRequest<CanvasMediaObjectLinkDTO>(Api.canvasMediaObjectLinks + "/" + linkId)
            .send()
            .then(() => {});
    }
}
